import React, { ReactNode, createContext, useContext, useState } from 'react';
import { darkTheme } from '../styles/themes/dark';
import { lightTheme } from '../styles/themes/light';

interface ThemeContextType {
  theme: string;
  toggleTheme: (theme: string) => void;
  themeColors: typeof lightTheme | typeof darkTheme; // Type of theme colors
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const preferredTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  const [theme, setTheme] = useState<string>(preferredTheme);

  // useEffect(() => {
  //   const handler = (e: MediaQueryListEvent) => {
  //     setTheme(e.matches ? 'dark' : 'light');
  //   };
  //   const mediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
  //   mediaQueryList.addEventListener('change', handler);
  //   return () => {
  //     mediaQueryList.removeEventListener('change', handler);
  //   };
  // }, []);

  const toggleTheme = (theme: string) => {
    setTheme(theme);
  };

  const themeColors = theme === 'light' ? lightTheme : lightTheme;

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, themeColors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
